import type { CreateEntryInput } from '@schemas'
import type { PendingIntakeEntry } from './entry-intake-state'
import { DEFAULT_ENTRY_FEE, normalizeOptional } from '@/features/intake/utils'

/** The same durable intent is sent by immediate intake and replay. */
export function pendingEntryRequest(showId: string, entry: PendingIntakeEntry): CreateEntryInput {
  const clubId = entry.clubId?.trim() || undefined
  const clubName = entry.clubName?.trim() || undefined
  return {
    showId,
    classId: entry.classId,
    exhibitorId: entry.exhibitor.id,
    submissionId: entry.submissionId,
    ...(!entry.code.startsWith('TMP') ? { entryCode: entry.code } : {}),
    fees: DEFAULT_ENTRY_FEE,
    notes: normalizeOptional(entry.notes),
    ...(clubId ? { clubId } : clubName ? { clubName } : {}),
  }
}
